import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "styled-components";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { useNavigate } from "react-router-dom";

import Logo from "../../components/atoms/Logo";

import { supabase } from "../../lib/api";

import { QueryKeys } from "../../services/types";
import { getUserSession } from "../../services/getUserSession";
import { Pathnames } from "../../components/molecules/BottomNavigation";

const AuthPage = () => {
  const [session, setSession] = useState<any>(null);

  const navigate = useNavigate();

  const { data: userSession } = useQuery({
    queryFn: getUserSession,
    queryKey: [QueryKeys.SESSION],
  });

  useEffect(() => {
    if (userSession) {
      setSession(userSession);
    }

    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    if (session || userSession) {
      navigate(Pathnames.HOME);
    }

    return () => subscription.unsubscribe();
  }, [userSession, session, navigate]);

  return (
    <StyledAuthWrapper>
      <StyledLogoWrapper>
        <Logo large isBeta />
      </StyledLogoWrapper>

      <Auth
        supabaseClient={supabase}
        appearance={{
          extend: true,
          className: {
            anchor: "custom-anchor",
            button: "custom-button",
          },
          theme: ThemeSupa,
        }}
        theme="dark"
        providers={[]}
      />
    </StyledAuthWrapper>
  );
};

const StyledAuthWrapper = styled.div`
  width: 90%;
  margin: auto;
  margin-top: 20px;
  max-width: 400px;

  .custom-button {
    border-radius: 8px;
  }

  input {
    color: ${({ theme }) => theme.colors.text};
    border-radius: ${({ theme }) => theme.radii.default};
  }

  form {
    button.custom-button {
      background-color: ${({ theme }) => theme.colors.primary};
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.dark};
      &:hover {
        background-color: #ebc004;
      }
    }
  }
`;

const StyledLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default AuthPage;
